/** @format */

import ExpeditorOrdersEditPage from './ExpeditorOrdersEditPage';
export default ExpeditorOrdersEditPage;
